import React, { useContext } from "react";
import {
  ScheduleComponent,
  Month,
  Inject,
  ViewsDirective,
  ViewDirective,
  TimelineViews,
  ResourcesDirective,
  ResourceDirective,
  TimelineMonth,
  MonthAgenda,
  Day,
} from "@syncfusion/ej2-react-schedule";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";
import { formatDate } from "@telerik/kendo-intl";
import { BASE_FILE_URL } from "../../../constant";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";

const Scheduler = ({
  scheduleObj,
  eventData,
  selectedAsset,
  assets,
  setEventsData,
  renderType,
  scheduleId,
  handleAssetClick,
}) => {
  let editingScheduleId;
  const onPopupOpen = (args) => {
    editingScheduleId = args.data.Id;
  };
  const { t } = useTranslation();
  const { config } = useContext(AppContext);

  const editorTemplate = (props) => {
    return props !== undefined ? (
      <table className="custom-event-editor gap-3">
        <tbody>
          <tr>
            <td className="e-textlabel"> {t("masters.fields.asset")}</td>
            <td colSpan={4} className="p-2">
              <select
                id="assetId"
                name="assetId"
                value={props?.assetId || selectedAsset?.id}
                className="e-field block placeholder:text-white border-grey-light rounded-lg bg-[#363945] text-white px-2 w-full h-8"
              >
                <option selected>{t("masters.fields.chooseCountry")}</option>
                {assets.map((x) => (
                  <option value={x.id}>{x.name}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td className="e-textlabel">{t("masters.labels.from")}</td>
            <td colSpan={4} className="p-2">
              <DateTimePickerComponent
                format="dd/MM/yy hh:mm a"
                id="StartTime"
                data-name="StartTime"
                value={new Date(props.StartTime)}
                className="e-field"
              ></DateTimePickerComponent>
            </td>
          </tr>
          <tr>
            <td className="e-textlabel">{t("masters.labels.to")}</td>
            <td colSpan={4} className="p-2">
              <DateTimePickerComponent
                format="dd/MM/yy hh:mm a"
                id="EndTime"
                data-name="EndTime"
                value={new Date(props.EndTime)}
                className="e-field"
              ></DateTimePickerComponent>
            </td>
          </tr>
          <tr>
            <td className="e-textlabel">{t("masters.fields.description")}</td>
            <td colSpan={4} className="p-2">
              <textarea
                id="Description"
                className="e-field block placeholder:text-white border-grey-light rounded-lg bg-[#363945] text-white p-2 w-full h-9"
                name="Description"
                value={props?.description}
                rows={3}
                cols={50}
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    ) : (
      <div></div>
    );
  };

  const onRendercell = (args) => {
    if (args.date) {
      args.element.style.color = "white";
      args.element.style.background = "#2b2b2b";
    }
  };

  const eventTemplate = (props) => {
    return (
      <div
        className="px-2 py-1"
        style={{
          borderColor: props.assetColor,
          borderLeftWidth: "4px",
          width: "130px",
          height: "48px",
        }}
      >
        <div className=" text-xxs">{props.assetName}</div>
        {/* <div className=" text-xs">
          {formatDate(new Date(props.StartTime), "dd-MMM-yyyy")}
          &nbsp;-&nbsp;
          {formatDate(new Date(props.EndTime), "dd-MMM-yyyy")}
        </div> */}
      </div>
    );
  };

  const onPopupClose = (args) => {
    if (args.type === "Editor" && args.data) {
      setEventsData((pre) => {
        const eventExists = pre.find((x) => x.Id === editingScheduleId);
        if (eventExists) {
          return pre.map((x) =>
            x.Id === editingScheduleId ? { ...x, ...args.data } : x
          );
        } else return [...pre, args.data];
      });
    }
  };
  const eventSettings = {
    dataSource: selectedAsset
      ? eventData
          .filter((x) => x.assetId === selectedAsset.id)
          .map((x) => [...x.schedules])
          .flat()
      : eventData.map((x) => [...x.schedules]).flat() || [],
    template: eventTemplate,
  };

  const group =
    renderType === "scheduleDetails"
      ? { resources: ["Asset"] }
      : { resources: ["Schedule", "Asset"] };

  const generateResourceData = (returnType) => {
    if (returnType === "asset") {
      if (renderType === "scheduleDetails") {
        const data = eventData.map((x) => ({
          Id: x.assetId,
          Name: x.assetName,
          Color: x.schedules[0]?.assetColor,
          schedules: x.schedules,
          IsExpand: true,
        }));
        return data;
      } else {
        const data = eventData.map((x) => ({
          Id: x.assetId,
          Name: x.assetName,
          Color: x.schedules[0]?.assetColor,
          GroupId: x.scheduleId,
          schedules: x.schedules,
          IsExpand: true,
        }));
        return data;
      }
    } else if (returnType === "schedule") {
      const data = eventData.map((x) => ({
        Id: x.scheduleId,
        Name: x.scheduleName,
        startDate: x.scheduleStart,
        endDate: x.scheduleEnd,
        Color: "white",
        IsExpand: true,
      }));
      const uniqueData = Array.from(new Set(data.map((item) => item.Id))).map(
        (id) => {
          return data.find((item) => item.Id === id);
        }
      );
      return uniqueData;
    }
  };

  const resourceHeaderTemplate = (props) => {
    if (props.resource.field === "scheduleId")
      return schedulerHeaderTemplate(props);
    else if (props.resource.field === "assetId")
      return assetHeaderTemplate(props);
  };

  const schedulerHeaderTemplate = (props) => {
    return (
      <div
        className={`${
          props.resource.field === "assetId"
            ? "bg-gray-900 rounded-md border-l-8 gap-3 w-72 h-12 p-4 ml-8"
            : "mt-1"
        }  flex flex-col gap-1 text-white pr-2`}
        style={{ borderColor: props.resourceData.Color }}
      >
        <div>{props.resourceData.Name}</div>
        <div className="flex justify-between items-center w-fit">
          <div className="flex gap-1 items-end">
            <div className="text-xxxs text-neutral-400">
              {" "}
              {t("masters.labels.from")}
            </div>
            <div className="text-xxs">
              {formatDate(
                new Date(props.resourceData.startDate),
                "dd-MMM-yyyy"
              )}
            </div>
          </div>
          &nbsp;/&nbsp;
          <div className="flex gap-1 items-end">
            <div className="text-xxxs text-neutral-400">
              {t("masters.labels.to")}
            </div>
            <div className="text-xxs">
              {formatDate(new Date(props.resourceData.endDate), "dd-MMM-yyyy")}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const assetHeaderTemplate = (props) => {
    const asset = assets.find((x) => x.id === props.resourceData.Id);
    return (
      <button
        className={`flex border-l-8 gap-3 w-72 text-white rounded-md justify-between ${
          renderType === "scheduleDetails" ? "" : "ml-10"
        } h-12 px-2 items-center ${
          selectedAsset && selectedAsset.id === asset.id
            ? "bg-blue-500"
            : "bg-gray-900 hover:bg-cyan-600"
        }`}
        style={{ borderColor: props.resourceData.Color }}
        onClick={() => handleAssetClick(asset)}
        key={props.resourceData.Id}
      >
        <div className="flex gap-3">
          {renderType === "scheduleDetails" && (
            <div>
              {asset && asset.imageId && !asset.imageId.startsWith("0000") ? (
                <img
                  src={`${BASE_FILE_URL}/${asset.imageId}`}
                  alt="AssaetTypeIcon"
                  className="h-auto w-12 image-full hover:fill-white"
                />
              ) : (
                <img
                  src="trucksvg.svg"
                  alt="AsseeetTypeIcon1"
                  className=" w-8 hover:fill-white"
                />
              )}
            </div>
          )}

          <div className="w-20 text-start">
            <label className="font-normal">{props.resourceData?.Name}</label>
            {renderType === "scheduleDetails" && (
              <div className="text-xxs gap-2 flex items-center font-normal">
                <div
                  className={`h-2 w-2  rounded-full ${
                    asset?.active ? "bg-green-600" : "bg-red-600"
                  }`}
                ></div>
                {asset?.active
                  ? t("masters.labels.active")
                  : t("masters.labels.inactive")}
              </div>
            )}
          </div>

          {renderType === "scheduleDetails" && (
            <div className="pr-1 tooltip w-10 self-end">
              <span
                className="tooltiptext text-xxs font-normal z-100 ml-11"
                style={{ marginLeft: "-44px" }}
              >
                {props.resourceData.schedules.length === 0
                  ? t("masters.labels.notScheduled")
                  : t("masters.labels.scheduled")}
              </span>
              {props.resourceData.schedules.length === 0 ? (
                <img src="notScheduleIcon.svg" className="h-5" />
              ) : (
                <img src="scheduleIcon.svg" className="h-5" />
              )}
            </div>
          )}
        </div>
      </button>
    );
  };

  return (
    <ScheduleComponent
      width="100%"
      height="100%"
      id={scheduleId}
      ref={scheduleObj}
      showTimeIndicator={false}
      eventSettings={eventSettings}
      editorTemplate={editorTemplate.bind(this)}
      showQuickInfo={false}
      popupOpen={onPopupOpen.bind(this)}
      renderCell={onRendercell}
      timezone={config?.timeZone}
      group={group}
      selectedDate={(() => {
        const startTimes = eventSettings.dataSource
          .map((x) => new Date(x.StartTime).getTime())
          .filter((time) => !isNaN(time));
        return startTimes.length
          ? new Date(Math.min(...startTimes))
          : new Date();
      })()}
      resourceHeaderTemplate={resourceHeaderTemplate.bind(this)}
      // eventRendered={onEventRendered}
      // popupClose={onPopupClose}
    >
      {/* <HeaderRowsDirective>
        <HeaderRowDirective option="Month" />
        <HeaderRowDirective option="Date" />
      </HeaderRowsDirective> */}
      <ResourcesDirective>
        {renderType === "scheduleList" && (
          <ResourceDirective
            field="scheduleId"
            title="Schedules"
            name="Schedule"
            dataSource={generateResourceData("schedule") || []}
            textField="Name"
            allowMultiple={true}
            idField="Id"
            colorField="Color"
          ></ResourceDirective>
        )}
        <ResourceDirective
          field="assetId"
          title="Assets"
          name="Asset"
          allowMultiple={true}
          dataSource={generateResourceData("asset") || []}
          textField="Name"
          groupIDField="GroupId"
          idField="Id"
          colorField="Color"
        ></ResourceDirective>
      </ResourcesDirective>
      <ViewsDirective>
        <ViewDirective
          option="TimelineMonth"
          interval={1}
          readonly
          timeScale={{ enable: false }}
        />
        <ViewDirective
          option="Month"
          orientation="Vertical"
          allowVirtualScrolling
          readonly
        />
        <ViewDirective
          option="TimelineYear"
          readonly
          interval={12}
          timeScale={{ enable: false }}
        />
      </ViewsDirective>
      <Inject
        services={[TimelineViews, TimelineMonth, Month, MonthAgenda, Day]}
      />
    </ScheduleComponent>
  );
};

export default Scheduler;
